import script from "./Press.vue?vue&type=script&setup=true&lang=js"
export * from "./Press.vue?vue&type=script&setup=true&lang=js"

import "./Press.vue?vue&type=style&index=0&id=e14c8f42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e14c8f42"]])

export default __exports__